import React, { useEffect, useState, useRef } from 'react'
import { Box, Toolbar, Typography, Link } from '@mui/material'

import { useLanguage } from '../context/LanguageContext';
import logo from '../Image/logo.png';
import mpcst from '../Image/newmpcst-logo.jpg';
import { useLocation } from "react-router-dom";
import Footer from '../Component/Footer';
import DesktopFooter from "../Component/Desktopfooter";
import Results from '../Component/Results';
import axios from "axios";
import { useNavigate } from "react-router-dom";
import { useMode } from "../context/modeContext";
import Header from "../Component/header";


const Result = () => {

  const { t } = useLanguage();

  const location = useLocation();
  const answers = location.state?.answers || [];
  const phone = location.state?.phone || null;

  const name = location.state?.name || null;
  const dob = location.state?.dob || null;
  const gender = location.state?.gender || null;
  const address = location.state?.address || null;


  const hasSaved = useRef(false);
  const navigate = useNavigate();
     const { mode } = useMode();
     console.log("MODE FOR STATE OF PAGE: "+mode);

 
     const getScreeningResult = () => {
      if (!answers || answers.length === 0)
        return "Need further examination by a specialist";
    
      const allAnswers = answers.map(a =>
        String(a.answer).toLowerCase()
      );
    
      const has = (keyword) =>
        allAnswers.some(ans => ans.includes(keyword));
    
      // Habits
      const smoke = has("cigarette") || has("bidi") || has("cigar") || has("hookah");
      const alcohol = has("alcohol");
      const areca = has("gutka") || has("paan");
    
      // Symptoms
      const whitePatch = has("white");
      const redPatch = has("red");
      const burning = has("burning");
      const difficultyOpening = has("open");
      const tightness = has("stiff");
      const looseTeeth = has("loose");
      const thickened = has("thick");
      const ulcer = has("ulcer");
      const stress = has("stress");
      const sharpEdges = has("sharp");
    
      // ==============================
      // 1. NORMAL MUCOSA
      // ==============================
      if (ulcer && !has("more than 14 days")) {
        return "Normal mucosa (Ulcer < 14 days)";
      }
    
      // ==============================
      // 2. SUSPECTED ORAL CANCER (STRICT AND)
      // ==============================
      if (
        looseTeeth &&
        (thickened || sharpEdges)
      ) {
        return "Suspected Oral Cancer – Urgent specialist consultation required";
      }
    
      // ==============================
      // 3. OSMF (STRICT AND)
      // ==============================
      if (
        (smoke || areca || alcohol) &&
        burning &&
        difficultyOpening &&
        tightness
      ) {
        return "Oral Submucous Fibrosis (OSMF)";
      }
    
      // ==============================
      // 4. OLP (STRICT AND)
      // ==============================
      if (
        stress &&
        burning &&
        whitePatch
      ) {
        return "Oral Lichen Planus (OLP)";
      }
    
      // ==============================
      // 5. ERYTHROPLAKIA (STRICT AND)
      // ==============================
      if (
        (smoke || areca || alcohol) &&
        redPatch
      ) {
        return "Erythroplakia";
      }
    
      // ==============================
      // 6. LEUKOPLAKIA (STRICT AND)
      // ==============================
      if (
        (smoke || areca || alcohol) &&
        whitePatch
      ) {
        return "Leukoplakia";
      }
    
      // ==============================
      // 7. OTHER OPMDs
      // ==============================
      if (
        whitePatch ||
        redPatch ||
        burning ||
        ulcer
      ) {
        return "Other Oral Potentially Malignant Disorder (OPMD)";
      }
    
      // ==============================
      // 8. DEFAULT
      // ==============================
      return "Healthy";
    };







  const getRiskHabits = () => {
    if (!answers || answers.length === 0) return [];
  
    const riskyHabits = [];
  
    answers.forEach((item) => {
      const answer = String(item.answer).toLowerCase();
  
      if (answer.includes("cigarette") || 
          answer.includes("bidi") || 
          answer.includes("cigar") || 
          answer.includes("hookah")) {
        riskyHabits.push("Smoking");
      }
  
      if (answer.includes("alcohol")) {
        riskyHabits.push("Alcohol Consumption");
      }
  
      if (answer.includes("gutka") || 
          answer.includes("paan") || 
          answer.includes("areca") || 
          answer.includes("betel")) {
        riskyHabits.push("Areca Nut / Gutkha");
      }
    });
  
    return [...new Set(riskyHabits)]; // remove duplicates
  };
  const screeningResult = getScreeningResult();
  const riskHabits = getRiskHabits();

  const saveUserAnswers = async (answers) => {
    console.log("Saving once:", answers);
    console.log("phone:", phone);


    const data = {
      
      user_number: phone,
      answers: answers,
      screening_result: screeningResult,
      risk_habits: riskHabits,
      page_state: mode,
      name: name,
      dob: dob,
      gender: gender,
      address: address,
    };
  
    try {
      const response = await axios.post(
        "/api/save-user-questions",
        data
      );
      console.log("Saved data: ");
      console.log(response.data);
    } catch (error) {
      console.error("Error saving data:", error);
    }
  };



  useEffect(() => {
    if (hasSaved.current) return;
  
    hasSaved.current = true;
  
    saveUserAnswers(answers);
    
  
  }, [answers]);
 
 

  return (
    <>
      <div className='text-Wrapper'>
       <Header/>
                <div className='result-wrap'>
                  <Box>
                  <Toolbar>
                     <Results screeningResult={screeningResult} 
                        phone={phone}
                        riskhabits={riskHabits}
                        name={name}
                        dob={dob}
                        gender={gender}
                        address={address}
                    />
                  
                  </Toolbar>
                </Box>
                </div>
            </div>
            <Footer />
             <DesktopFooter/>
      
    </>
  )
}
export default Result